import Switch from "react-switch";

const SntOnOffSwitch = ({
  checked,
  onChange,
  disabled,
  className = "",
  title,
}) => {
  const handleChange = (checked) => {
    onChange && onChange(checked);
  };

  return title ? (
    <div
      className={`${className}`}
      style={{ alignItems: "center", display: "flex" }}
    >
      <span className="me-1">{title}</span>
      <Switch checked={checked} onChange={handleChange} disabled={disabled} />
    </div>
  ) : (
    <label className={`${className}`}>
      <Switch checked={checked} onChange={handleChange} disabled={disabled} />
    </label>
  );
};

export default SntOnOffSwitch;
